import React from 'react';

export const IncomingCallIcon = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7559 5.24115C15.0814 5.56658 15.0814 6.09422 14.7559 6.41966L6.42259 14.753C6.09715 15.0784 5.56951 15.0784 5.24408 14.753C4.91864 14.4276 4.91864 13.8999 5.24408 13.5745L13.5774 5.24115C13.9028 4.91571 14.4305 4.91571 14.7559 5.24115Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83333 5.83664C6.29357 5.83664 6.66667 6.20974 6.66667 6.66998V13.3366H13.3333C13.7936 13.3366 14.1667 13.7097 14.1667 14.17C14.1667 14.6302 13.7936 15.0033 13.3333 15.0033H5.83333C5.3731 15.0033 5 14.6302 5 14.17V6.66998C5 6.20974 5.3731 5.83664 5.83333 5.83664Z"
      fill="#6B7280"
    />
  </svg>
);
